import React from 'react';
import type { Countdown } from '@/types/common';

interface CountdownTimerProps {
  timeLeft: Countdown;
}

const CountdownTimer: React.FC<CountdownTimerProps> = ({ timeLeft }) => (
  <div className="text-start">
    <div className="mb-3">
      <span className="text-orange-300 font-semibold">Event Starts in</span>
    </div>
    <div className="flex justify-start gap-4 text-center">
      {[
        { value: timeLeft.days, label: 'Days' },
        { value: timeLeft.hours, label: 'Hours' },
        { value: timeLeft.minutes, label: 'Mins' },
        { value: timeLeft.seconds, label: 'Secs' }
      ].map((item, index) => (
        <div key={index} className="flex flex-col items-center">
          <div className="text-2xl md:text-3xl font-bold bg-black/45 text-white p-3 rounded-lg border-2 border-orange-300/25 w-12 h-12 md:w-14 md:h-14 flex items-center justify-center">
            {String(item.value).padStart(2, '0')}
          </div>
          <div className="text-xs text-gray-300 mt-1">{item.label}</div>
        </div>
      ))}
    </div>
  </div>
);

export default CountdownTimer;